import { render, staticRenderFns } from "./manual_invoice.vue?vue&type=template&id=454090f9&"
import script from "./manual_invoice.vue?vue&type=script&lang=js&"
export * from "./manual_invoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports